import queryKeys from '@/constants/queryKeys';
import { getCreatorApplicationById } from '@/services/api/requests/creator-applications';
import { useQuery } from '@tanstack/react-query';

const useCreatorApplicationById = (id: string) => {
  const { isPending, isLoading, isSuccess, data, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.creatorApplications.byId, id],
    queryFn: async () => {
      const response = await getCreatorApplicationById(id);
      return response;
    },
  });

  return { isPending, isLoading, isSuccess, data, isRefetching, refetch };
};

export default useCreatorApplicationById;
